var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sayfayok[data-v-e460386e]{background-image:url(" + escape(require("../../assets/img/error-404.svg")) + ");position:fixed;z-index:99999;width:100%;height:100%;background-repeat:no-repeat;background-size:cover;top:0;right:0;background-position:50%;text-align:center;padding-top:10vh}.h1[data-v-e460386e]{text-shadow:1px 1px 13px #fff;color:#de4337}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e460386e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/spesiyal/SayfaYok.vue
// module id = 553
// module chunks = 0